@if (!creditOnly()) {
  @if (loaded()) {
    @if (tenantLogo(); as tenant) {
      <img
        class="branding-primary"
        [src]="tenant.url"
        alt="Brand logo"
      />
    } @else if (!showPoweredBy()) {
      <img
        class="branding-primary"
        [src]="isDarkMode() ? 'assets/logo-white.svg' : 'assets/logo.svg'"
        alt="Speaksee logo"
      />
    }
  } @else {
    <span class="branding-primary" aria-hidden="true"></span>
  }
}

@if (!logoOnly() && (creditOnly() || showPoweredBy())) {
  <div class="branding-powered-by">
    <span>{{ 'branding.powered_by' | transloco }}</span>
    <img
      class="branding-credit"
      src="assets/speaksee-avatar.png"
      alt="Speaksee"
    />
  </div>
}
